// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"2962ddf4b6c045e1","4439":"56774d582518b8f4","5801":"a92a830fcfe7dd37","7744":"a52b27b0b5425bb5","7746":"8091b70576714eb2","9591":"959cbddafd66f297","9860":"924c4ef7b05fe638"}[chunkId] + ".1780484557133.js";
};